import {CodeNodeDef} from "../../parser/definition/types/CodeNodeDef";
import {DependencyDef} from "../../parser/definition/types/DependencyDef";
import {NodeDef} from "../../parser/definition/types/NodeDef";
import {StructureNodeDef} from "../../parser/definition/types/StructureNodeDef";
import {isCodeNodeDef} from "./isCodeNodeDef";
import {isStructureNodeDef} from "./isStructureNodeDef";

export function getDependenciesFromNodeDef<I, O>(
  nodeDef: NodeDef<I, O>
): Array<DependencyDef> {
  if (isCodeNodeDef(nodeDef)) {
    const codeNodeDef = nodeDef as CodeNodeDef<I, O>;
    return codeNodeDef.dependencies;
  } else if (isStructureNodeDef(nodeDef)) {
    const structureNodeDef = nodeDef as StructureNodeDef<I, O, any>;
    return structureNodeDef.dependencies;
  } else {
    return [];
  }
}
